import { saveAs } from "file-saver";

import type { PaymentExportCategory } from "../../domain/models/Import";
import type { MissingCardPaymentState } from "@/types/payments";
import type {
  KpiResponse,
  PaymentsScopeParams,
} from "../../domain/models/PaymentsKpi";
import { inflateBlobErrorBody } from "@/utils/apiError";
import { BaseService } from "./BaseService";

const DEFAULT_EXPORT_FILENAMES: Record<PaymentExportCategory, string> = {
  telecollections: "telecollectes.xlsx",
  missing_card_payments: "cb_manquantes.xlsx",
  national_transfers: "virements_nationaux.xlsx",
};

export type PaymentsExportParams = PaymentsScopeParams & {
  type: PaymentExportCategory;
  done?: boolean;
  search?: string;
  state?: MissingCardPaymentState;
  dealerships?: string[];
};

class PaymentsService extends BaseService {
  constructor() {
    super({
      pathname: "payments",
      apiUrl: process.env.NEXT_PUBLIC_FLUX_API_URL,
    });
  }

  async getKpi(params: PaymentsScopeParams = {}): Promise<KpiResponse> {
    const response = await this.api.get<KpiResponse>("/kpi", { params });

    return response.data;
  }

  async exportPayments({
    type,
    ...scope
  }: PaymentsExportParams): Promise<void> {
    const response = await this.api
      .get<Blob>("/export", {
        params: { type, ...scope },
        responseType: "blob",
      })
      .catch(async (error: unknown) => {
        throw await inflateBlobErrorBody(error);
      });

    const contentDisposition = response.headers["content-disposition"];
    const filename =
      contentDisposition?.match(/filename="?([^"]+)"?/)?.[1] ??
      DEFAULT_EXPORT_FILENAMES[type];

    saveAs(response.data, filename);
  }
}

export const paymentsService = new PaymentsService();
